export const COMMISSION_STATUS = {
  PAID: 'PAID',
  GST: 'GST',
  PENDING: 'PENDING',
  NO_COMM: 'NO_COMM',
};

export const COMMISSION_STATUS_LABELS = {
  PAID: 'Paid',
  GST: 'GST',
  PENDING: 'Pending',
  NO_COMM: 'No commission',
};

export const COMMISSION_STATUS_COLORS = {
  PAID: 'green',
  GST: 'blue',
  PENDING: 'gold',
  NO_COMM: 'default',
};

export const COMMISSION_STATUS_OPTIONS = Object.values(COMMISSION_STATUS).map((value) => ({
  value,
  label: COMMISSION_STATUS_LABELS[value],
}));

export const DEFAULT_PAGE_SIZE = 20;

export const PRODUCT_TYPE_OTHER = 'Other';

export const BUYER_PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const ISIN_LENGTH = 12;

export const OFFLINE_IFA_PARTNER_LIST_PARAMS = {
  status: 'active',
  sort_by: 'name',
  sort_order: 'asc',
};

/** IFA commission form input mode — API always stores rupees. */
export const IFA_COMMISSION_MODE_PERCENT = 'percent';
export const IFA_COMMISSION_MODE_AMOUNT = 'amount';

export const IFA_COMMISSION_MODE_OPTIONS = [
  { label: '%', value: IFA_COMMISSION_MODE_PERCENT },
  { label: '₹', value: IFA_COMMISSION_MODE_AMOUNT },
];
